import { Flame, Thermometer, Snowflake } from 'lucide-react';
import { clsx } from 'clsx';

interface LeadScoreDistributionProps {
  hot: number;
  warm: number;
  cold: number;
}

export default function LeadScoreDistribution({
  hot,
  warm,
  cold,
}: LeadScoreDistributionProps) {
  const total = hot + warm + cold;

  const items = [
    {
      label: 'Heiss',
      value: hot,
      icon: Flame,
      color: 'text-red-600',
      bgColor: 'bg-red-100',
      barColor: 'bg-red-500',
    },
    {
      label: 'Warm',
      value: warm,
      icon: Thermometer,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100',
      barColor: 'bg-yellow-500',
    },
    {
      label: 'Kalt',
      value: cold,
      icon: Snowflake,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      barColor: 'bg-blue-500',
    },
  ];

  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Leadprioritat Verteilung
      </h3>

      {total === 0 ? (
        <div className="h-48 flex items-center justify-center text-gray-500">
          Keine Daten verfugbar
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((item) => {
            const percentage = total > 0 ? Math.round((item.value / total) * 100) : 0;
            const Icon = item.icon;

            return (
              <div key={item.label}>
                <div className="flex items-center justify-between mb-1">
                  <div className="flex items-center space-x-2">
                    <div className={clsx('p-1.5 rounded', item.bgColor)}>
                      <Icon className={clsx('w-4 h-4', item.color)} />
                    </div>
                    <span className="text-sm font-medium text-gray-700">
                      {item.label}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-semibold text-gray-900">
                      {item.value}
                    </span>
                    <span className="text-sm text-gray-500">({percentage}%)</span>
                  </div>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className={clsx('h-2 rounded-full transition-all', item.barColor)}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="text-center">
          <p className="text-3xl font-bold text-gray-900">{total}</p>
          <p className="text-sm text-gray-500">Bewertete Calls</p>
        </div>
      </div>
    </div>
  );
}
